export const YOUDAOADS_REGISTER_INFO = 'YOUDAOADS_REGISTER_INFO';
